import { LegalPolicyConsentKind } from '@src/types'

interface PolicyConsentStatus<Policy> {
  kind: LegalPolicyConsentKind
  required: boolean
  policy: Policy
}

/**
 * Required policies that block using the app until accepted. The AI processing consent is excluded:
 * it's optional and only asked for when the member uses Nora (see useAiProcessingConsentGate).
 */
export const getBlockingRequiredPolicies = <Policy>(statuses: PolicyConsentStatus<Policy>[]) =>
  statuses.flatMap((status) =>
    status.required && status.kind !== LegalPolicyConsentKind.AiProcessing ? [status.policy] : [],
  )
